import { render } from "./BracketNode.vue?vue&type=template&id=3c68116a"
import script from "./BracketNode.vue?vue&type=script&lang=js"
export * from "./BracketNode.vue?vue&type=script&lang=js"

import "./BracketNode.vue?vue&type=style&index=0&id=3c68116a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__